import { TutorInterface } from '../interface/tutor_interface';
import { DocumentReference } from '@angular/fire/firestore/interfaces';
import firebase from 'firebase';



export class Tutor implements  TutorInterface{

  constructor() {
  }
  phone2: string;
  contactFormTutor: any;
  dobDatePicker: any;
  age: number;
  originTutor: DocumentReference<firebase.firestore.DocumentData>;
  paymentType: string;
  number: string;
  swiftBicTitular: string;
  paymentMethodDescription: any;
  appCreacion: string;
  id: any;
  medioContacto: string;
  idUserAuth: any;
  userType: any;
  fullname: any;
  alumns: DocumentReference[];
  centro: DocumentReference[];
  firstname: string;
  lastname: string;
  dob: any;
  sexo: string;
  parentesco: string;
  document: string;
  numberDNI: string;
  phone1: string;
  tipoVia: string;
  adress: string;
  zip: string;
  city: string;
  email: string;
  password: any;
  active: boolean;
  prevStatus: any;
  status: any;
  registrationDate: any;
  roles: any;
  paymentMethod: any;
  IBAN: any;
  titularPayment: any;
  documentTitular: any;
  numberDNITitular: any;
  addressTitular: any;
  numberTitular: any;
  municipalityTitular: any;
  paymentMethodName: any;
  cityTitular: any;
  zipTitular: any;
  countryTitular: any;
  swiftBic: any;
  dateTitular: any;
  listCourses: any[];
  listCenters: any[];
  course: any;
  horarioSelected: any;
  nombreCentro: any;
  meses: any;
  mesInscripcion: any;
  municipality: any;
  address: any;
  day: any;
  studentSelected: any;
  disableContract: any;
  isCampus: any;
}
